jQuery(function ($) {
  // Override URL copying logic / style
  const url = $(window.location).attr('href');
  let $copyLink;

  const onCopySuccess = () => {
    $copyLink.addClass('copied');
    setTimeout(() => $copyLink.removeClass('copied'), 2000);
  };

  const doCopyFallback = () => {
    // https://codepen.io/andrea89/pen/xYJLxG
    const $temp = $('<input>');

    $('body').append($temp);
    $temp.val($url).select();
    document.execCommand('copy');
    $temp.remove();

    onCopySuccess();
  };

  $('.a2a_button_copy_link').each(function () {
    this.addEventListener(
      'click',
      function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        $copyLink = $(this);

        if ($copyLink.hasClass('copied')) {
          return false;
        }

        if ('clipboard' in navigator) {
          navigator.clipboard.writeText(url).then(onCopySuccess, doCopyFallback);
        } else {
          doCopyFallback();
        }
      },
      true,
    );
  });
});
